import * as yup from 'yup';

import { makeValidateSync } from '@cast/utils';

import { KeyVal } from 'core/forms';

export type EdgeConfigurationFormValues = {
  edgeLocationId: string;
  name: string;
  tags: KeyVal[];
  bootDiskSizeGib: string;
  imageId: string;
  criSocketPath: string;
  default: boolean;
  initScript: string;
  sshPublicKey: string;
  gpuCluster: string;
  reservationIds: string[];
};

const validationSchema = yup.object({
  edgeLocationId: yup.string().required('Edge location is required'),
  name: yup.string().required('Configuration name is required'),
  bootDiskSizeGib: yup
    .string()
    .test(
      'is-positive-integer',
      'Disk size must be a positive integer',
      (value) => {
        if (!value) return true;
        return /^\d+$/.test(value) && Number(value) > 0;
      }
    ),
  tags: yup.array().of(
    yup.object({
      key: yup.string(),
      value: yup.string().when('key', {
        is: (key: string | undefined) => !!key,
        then: (schema) =>
          schema.required('Value is required when key is present'),
        otherwise: (schema) => schema,
      }),
    })
  ),
  criSocketPath: yup.string(),
  imageId: yup.string(),
  default: yup.boolean(),
  initScript: yup.string(),
  sshPublicKey: yup.string(),
  gpuCluster: yup.string(),
  reservationIds: yup.array().of(yup.string().trim().min(1)),
});

export const validate = makeValidateSync(validationSchema);
